export const is_pdp_benefit_coupon_download = 'is_pdp_benefit_coupon_download';

export const pdp_benefit_coupon_policy_id = 'pdp_benefit_coupon_policy_id';
